"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRemainingSeconds = getRemainingSeconds;
var _decodeToken = require("../utils/decodeToken");
function getRemainingSeconds(token) {
  if (!token) {
    return 0;
  }
  const decoded = (0, _decodeToken.decodeToken)(token);
  if (!decoded) {
    return 0;
  }
  const {
    exp
  } = decoded;
  const remaining = Math.floor(exp - Date.now() / 1000);
  return remaining < 0 ? 0 : remaining;
}
//# sourceMappingURL=getRemainingSeconds.js.map